export const CURRENCIES = [
    { value: 'USD', label: 'USD ($)' },
    { value: 'EUR', label: 'EUR (€)', disabled: true },
    { value: 'GBP', label: 'GBP (£)', disabled: true },
    { value: 'JPY', label: 'JPY (¥)', disabled: true },
    { value: 'CAD', label: 'CAD (C$)', disabled: true },
    { value: 'AUD', label: 'AUD (A$)', disabled: true },
    { value: 'INR', label: 'INR (₹)', disabled: true },
];

export const PANEL_FOR_MODEL = {
    monthly: 'recurring',
    weekly: 'recurring',
    quarterly: 'recurring',
    annual: 'recurring',
    one_time: 'oneTime',
    ongoing: 'ongoing',
    milestone: 'milestone',
    custom: 'custom',
};

export function formatDateInput(value) {
    if (!value) return '';
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
    const d = new Date(String(value).slice(0, 10) + 'T00:00:00');
    if (Number.isNaN(d.getTime())) return '';
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${d.getFullYear()}-${m}-${day}`;
}

export function todayIsoDate() {
    // Local calendar date (matches DateField / formatDateInput), not UTC ISO date
    const d = new Date();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${d.getFullYear()}-${m}-${day}`;
}

/** Vanilla DealFormManager.addInterval — one step forward from dateStr. */
export function addInterval(dateStr, model) {
    if (!dateStr) return '';
    const d = new Date(`${formatDateInput(dateStr)}T12:00:00`);
    if (Number.isNaN(d.getTime())) return '';
    if (model === 'weekly') d.setDate(d.getDate() + 7);
    else if (model === 'monthly') d.setMonth(d.getMonth() + 1);
    else if (model === 'quarterly') d.setMonth(d.getMonth() + 3);
    else if (model === 'annual') d.setFullYear(d.getFullYear() + 1);
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
}

/**
 * Recurring schedule builder matching vanilla generateRecurringScheduleRows:
 * - recomputeDates: re-space all rows from anchor using model interval
 * - otherwise: preserve existing row dates; new rows get addInterval from prior
 */
export function buildRecurringRows(model, count, startDate, amount, divideEqually, existingRows = [], { recomputeDates = false } = {}) {
    const rows = [];
    const n = Math.max(0, parseInt(count, 10) || 0);
    if (n < 1) return [];
    const existing = Array.isArray(existingRows) ? existingRows : [];
    let firstDate = '';
    if (existing[0]?.date) {
        firstDate = formatDateInput(existing[0].date);
    } else {
        firstDate = formatDateInput(startDate) || todayIsoDate();
    }
    if (!firstDate) return [];

    const contract = Number(amount) || 0;
    const baseInstallment = (divideEqually && contract > 0 && n > 0)
        ? Math.floor((contract / n) * 100) / 100
        : 0;
    let allocated = 0;

    for (let i = 0; i < n; i++) {
        let dateVal = '';
        if (i === 0) {
            dateVal = firstDate;
        } else if (recomputeDates) {
            dateVal = rows[i - 1]?.date ? addInterval(rows[i - 1].date, model) : (existing[i]?.date || '');
        } else if (existing[i]?.date) {
            dateVal = formatDateInput(existing[i].date);
        } else if (rows[i - 1]?.date) {
            dateVal = addInterval(rows[i - 1].date, model);
        }

        let amountVal = 0;
        if (divideEqually && contract > 0) {
            if (i === n - 1) {
                amountVal = Math.round((contract - allocated) * 100) / 100;
            } else {
                amountVal = baseInstallment;
                allocated += baseInstallment;
            }
        } else if (existing[i] && existing[i].amount != null && existing[i].amount !== '') {
            amountVal = Number(existing[i].amount) || 0;
        }

        rows.push({ date: dateVal, amount: amountVal });
    }
    return rows;
}

export function createEmptyDealForm() {
    return {
        dealName: '',
        dealDate: todayIsoDate(),
        dealClientId: '',
        dealOwnerUserId: '',
        dealCurrency: 'USD',
        dealAmount: '',
        dealStage: '',
        dealProbability: 0,
        expectedCloseDate: '',
        dealType: '',
        dealEngagementModel: '',
        dealServiceLine: '',
        dealPipeline: '',
        dealCampaignSource: '',
        dealLeadSource: '',
        referralContactId: '',
        referralName: '',
        referralEmail: '',
        dealLostReason: '',
        dealLostReasonCategory: '',
        dealPaymentTerms: '',
        dealPaymentModel: '',
        dealPaymentCount: 0,
        taxIncluded: false,
        taxRate: '',
        taxUsePercent: true,
        recurringScheduleRows: [],
        oneTimeDate: '',
        oneTimeAmount: '',
        retainerAmount: '',
        retainerUsePercent: false,
        estimatedAnnualValue: '',
        ongoingStartDate: '',
        ongoingEndDate: '',
        minCommitment: '',
        maxBudget: '',
        ongoingInvoiceFrequency: 'monthly',
        dealMilestones: [],
        customScheduleRows: [],
        divideEqually: true,
        contractValue: 0,
        contactRoles: [],
        primaryContactId: null,
        commissionEligible: true,
        commissionModel: 'percentage',
        commissionRate: '',
        commissionFixedAmount: '',
        commissionBasis: 'schedule',
        payoutMethod: 'per_schedule',
        commissionSplits: [],
        id: null,
        version: null,
        status: 'open',
    };
}

export function contactDisplayName(contact) {
    return `${contact.firstName || ''} ${contact.lastName || ''}`.trim() || contact.email || contact.id;
}
